import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetCompoundEntitiesDocument,
  type GetCompoundEntitiesQuery,
  type GetCompoundEntitiesQueryVariables,
} from "~/features/compoundEntities/gqls";
import type { CompoundSearchCondition } from "~/features/compoundEntities/types";
import { buildCompoundVariables } from "~/features/compoundEntities/utils/transformers";
import { useTenant } from "~/features/tenant/context";

interface UseCompoundEntityListArgs {
  conditions: readonly CompoundSearchCondition[];
  version?: string;
  gdtfFrom?: string;
  gdtfTo?: string;
  pageIndex: number;
  pageSize: number;
}

/**
 * Server-paginated list of compound records for the current tenant + selected
 * version. Compound records are read-only (no mutations), ordered newest-first.
 */
export function useCompoundEntityList({
  conditions,
  version,
  gdtfFrom,
  gdtfTo,
  pageIndex,
  pageSize,
}: UseCompoundEntityListArgs) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetCompoundEntitiesQuery, GetCompoundEntitiesQueryVariables>(GetCompoundEntitiesDocument, {
    variables: buildCompoundVariables({ tenantId, conditions, version, gdtfFrom, gdtfTo, pageIndex, pageSize }),
  });
}
